export default "__VITE_ASSET__67f00d24__"